import { QUICKBOOK_STATUSES } from 'appconstants';

export default value => {
  if (value === 'SUCCEEDED') {
    return QUICKBOOK_STATUSES.SUCCEEDED;
  } if (value === 'PENDING') {
    return QUICKBOOK_STATUSES.PENDING;
  } return QUICKBOOK_STATUSES.FAILED;
};
